import { acceptProjectBid } from '~/api/projectBids';
import Modal from '~/components/Modal';
import { useMutation } from 'react-query';
import { Button } from '~/components';
import { Project, ProjectBid } from '~/types/project';
import toast from 'react-hot-toast';
import { logUserActivity, UserActivityTypes } from '~/api/user';

interface AcceptProjectBidModalProps {
  project: Project
  bid: ProjectBid
  fetchProject: () => void
  closeModal: () => void
}

export default function AcceptProjectBidModal({
  project,
  bid,
  fetchProject,
  closeModal
}: AcceptProjectBidModalProps) {

  const { mutateAsync: acceptBid, status: acceptBidStatus } = useMutation(
    async () => {
      await acceptProjectBid(project?.id, bid?.id);
  });

  const handleAcceptBid = async () => {
    try {
      await acceptBid();
      logUserActivity({
        activityType: UserActivityTypes.BID_ACCEPTED,
        projectId: project?.id,
        metadata: {
          bidId: bid?.id,
          amount: bid?.amount,
          unit: bid?.unit,
        },
      });
      toast.success('Project bid accepted successfully.', { duration: 5000 });
      fetchProject();
      closeModal();
    } catch (error) {
      console.error('Error accepting project bid:', error);
      toast.error('An error occurred while accepting the project bid.', { duration: 5000 });
    }
  };

  return (
    <Modal 
      closeModal={acceptBidStatus === 'loading' ? undefined : closeModal} 
      allowClose={acceptBidStatus !== 'loading'}
    >
      <Modal.Title>Accept project bid?</Modal.Title>
      <Modal.Content>
        <p><strong>Are you sure you want to accept this project bid?</strong> This cannot be undone without contacting an administrator.</p>
      </Modal.Content>
      <Modal.Footer>
        <Button 
          primary 
          outlined 
          disabled={acceptBidStatus === 'loading'} 
          onClick={closeModal}
        >
          Go back
        </Button>
        <Button 
          primary 
          loading={acceptBidStatus === 'loading'} 
          disabled={acceptBidStatus === 'loading'} 
          onClick={() => handleAcceptBid()}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );    
}